import { ImageSwiper } from "../molecules";

const images1 = [
  "/img/slider-1-1.jpg",
  "/img/slider-1-2.jpg",
  "/img/slider-1-3.jpg",
];
const images2 = [
  "/img/slider-2-1.jpg",
  "/img/slider-2-2.jpg",
  "/img/slider-2-3.jpg",
];
const images3 = [
  "/img/slider-3-1.jpg",
  "/img/slider-3-2.jpg",
  "/img/slider-3-3.jpg",
];

const MySwiper: React.FC = () => {
  return (
    <div>
      <ImageSwiper images={images1} rtl />
      <ImageSwiper images={images2} top={-5} />
      <ImageSwiper images={images3} rtl top={-10} />
    </div>
  );
};

export default MySwiper;
